// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventoryDiv {
  width: 100%;
}
.inventoryDiv .imageError {
  background-color: red;
}
.inventoryDiv .bashDiv {
  padding-top: 20px;
  padding-left: 30px;
  display: flex;
  gap: 30px;
  position: relative;
}
.inventoryDiv .bashDiv .statisticButton {
  border: 1px solid #525252;
  border-radius: 10px;
  padding: 10px 15px;
  cursor: pointer;
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 41px;
  -webkit-user-select: none;
          user-select: none;
  width: auto;
}
.inventoryDiv .bashDiv .statisticButton:hover {
  color: white;
  border: 1px solid #fff;
}
.inventoryDiv .bashDiv .inventoryStatisticDiv {
  position: absolute;
  display: flex;
  gap: 30px;
  right: 30px;
  font-size: 14px;
}
.inventoryDiv .bashDiv .inventoryStatisticDiv p {
  color: gray;
}
.inventoryDiv .inventoryes {
  padding: 30px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
}
.inventoryDiv .inventoryes .inventoryItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
  border-radius: 15px;
  border: 1px solid gray;
  width: 300px;
  box-sizing: border-box;
  background-color: transparent;
  color: white;
  margin-top: 3px;
  padding-bottom: 40px;
  position: relative;
}
.inventoryDiv .inventoryes .inventoryItem p {
  color: white;
  width: 100%;
  font-size: 15px;
}
.inventoryDiv .inventoryes .inventoryItem p span {
  color: gray;
  font-size: 14px;
}
.inventoryDiv .inventoryes .inventoryItem .controllButtons {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 10px;
}
.inventoryDiv .inventoryes .inventoryItem .inventoryItemContent {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.inventoryDiv .inventoryes .inventoryItem .inventoryItemContent img {
  max-width: 100%;
  object-fit: contain;
}

.inventoryDialog .DemoContainer {
  padding-top: 15px;
}

.imageUploadDiv {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  object-fit: contain;
  gap: 10px;
}
.imageUploadDiv label {
  display: flex;
  justify-content: center;
}

@media (max-width: 850px) {
  .inventoryDiv .bashDiv {
    padding: 0 50px;
    box-sizing: border-box;
    flex-direction: column-reverse;
  }
  .inventoryDiv .bashDiv .inventoryStatisticDiv {
    position: relative;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .inventoryDiv .bashDiv .inventoryStatisticDiv p {
    margin: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/inventory/inventory.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AACI;EACI,qBAAA;AACR;AAEI;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AAAR;AAEQ;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,WAAA;AAAZ;AAEQ;EACI,YAAA;EACA,sBAAA;AAAZ;AAIQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAFZ;AAIY;EACI,WAAA;AAFhB;AAUI;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;AARR;AAWQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AATZ;AAWY;EACI,YAAA;EACA,WAAA;EACA,eAAA;AAThB;AAWgB;EACI,WAAA;EACA,eAAA;AATpB;AAaY;EACI,aAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAXhB;AAcY;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAZhB;AAcgB;EACI,eAAA;EACA,mBAAA;AAZpB;;AAuBI;EACI,iBAAA;AApBR;;AAyBA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAtBJ;AAwBI;EACI,aAAA;EACA,uBAAA;AAtBR;;AA0BA;EAEQ;IACI,eAAA;IACA,sBAAA;IACA,8BAAA;EAxBV;EA0BU;IACI,kBAAA;IACA,QAAA;IACA,aAAA;IACA,sBAAA;IACA,QAAA;EAxBd;EA0Bc;IACI,SAAA;EAxBlB;AACF","sourcesContent":[".inventoryDiv {\n    width: 100%;\n\n    .imageError {\n        background-color: red;\n    }\n\n    .bashDiv {\n        padding-top: 20px;\n        padding-left: 30px;\n        display: flex;\n        gap: 30px;\n        position: relative;\n\n        .statisticButton {\n            border: 1px solid #525252;\n            border-radius: 10px;\n            padding: 10px 15px;\n            cursor: pointer;\n            margin-top: 8px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            max-height: 41px;\n            user-select: none;\n            width: auto;\n        }\n        .statisticButton:hover {\n            color: white;\n            border: 1px solid #fff;\n\n        }\n\n        .inventoryStatisticDiv {\n            position: absolute;\n            display: flex;\n            gap: 30px;\n            right: 30px;\n            font-size: 14px;\n\n            p {\n                color: gray;\n            }\n\n            \n\n        }\n    }\n\n    .inventoryes {\n        padding: 30px;\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n        gap: 40px;\n\n\n        .inventoryItem {\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            align-items: flex-start;\n            padding: 10px;\n            border-radius: 15px;\n            border: 1px solid gray;\n            width: 300px;\n            box-sizing: border-box;\n            background-color: transparent;\n            color: white;\n            margin-top: 3px;\n            padding-bottom: 40px;\n            position: relative;\n\n            p {\n                color: white;\n                width: 100%;\n                font-size: 15px;\n\n                span {\n                    color: gray;\n                    font-size: 14px;\n                }\n            }\n\n            .controllButtons {\n                display: flex;\n                width: 100%;\n                justify-content: space-around;\n                align-items: center;\n                position: absolute;\n                bottom: 10px;\n            }\n\n            .inventoryItemContent {\n                width: 100%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                flex-direction: column;\n\n                img {\n                    max-width: 100%;\n                    object-fit: contain;\n\n                }\n\n            }\n\n        }\n    }\n}\n\n.inventoryDialog {\n    .DemoContainer {\n        padding-top: 15px;\n    }\n\n}\n\n.imageUploadDiv {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    object-fit: contain;\n    gap: 10px;\n\n    label {\n        display: flex;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 850px) {\n    .inventoryDiv {\n        .bashDiv {\n            padding: 0 50px;\n            box-sizing: border-box;\n            flex-direction: column-reverse;\n\n            .inventoryStatisticDiv {\n                position: relative;\n                right: 0;\n                display: flex;\n                flex-direction: column;\n                gap: 5px;\n\n                p {\n                    margin: 0;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
